import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CATEGORIES, getToolsByCategory } from '@/lib/tools';
import { useSeo } from '@/lib/seo';

export default function CategoriesPage() {
  useSeo({
    title: 'Calculator Categories — Math, Money, Time & Health',
    description: 'Browse free online calculators by category: math, money, time and date, unit and currency conversion, and health.',
    path: '/categories',
  });

  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hash]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <header className="mb-10">
        <h1 className="text-4xl sm:text-5xl font-bold text-slate-900">Calculator categories</h1>
        <p className="text-slate-600 mt-2 max-w-2xl">Grouped by real-world use — pick the area you need help with.</p>
      </header>

      <div className="space-y-14">
        {CATEGORIES.map((c) => {
          const tools = getToolsByCategory(c.id);
          return (
            <section key={c.id} id={c.id} className="scroll-mt-24">
              <div className={`rounded-2xl p-6 bg-gradient-to-br ${c.color} text-white mb-6`}>
                <h2 className="text-2xl font-semibold">{c.name}</h2>
                <p className="text-white/85 text-sm mt-1">{c.description}</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {tools.map((t) => {
                  const Icon = t.icon;
                  return (
                    <Link
                      key={t.slug}
                      to={`/tools/${t.slug}`}
                      data-testid={`category-tool-${t.slug}`}
                      className="group bg-white border border-slate-100 rounded-2xl p-6 hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all"
                    >
                      <div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-4">
                        <Icon className="w-5 h-5" />
                      </div>
                      <h3 className="text-lg font-semibold text-slate-900 group-hover:text-emerald-700">{t.name}</h3>
                      <p className="text-sm text-slate-600 mt-1 leading-relaxed">{t.tagline}</p>
                    </Link>
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
